import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { OptionsService } from '../services/options.service'
import { setPatientMedicalHistoryIcdNemsisBasicOptions } from '../store/options.actions'
import { filterHiddenOptions } from '../../../utilities/options.util'
import { IHideableOptionsResponse } from '../store/options.types'

export function* setMedicalHistoryIcdNemsisBasicOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const medicalHistoryResponse: IHideableOptionsResponse = yield call([
      optionsService,
      optionsService.getMedicalHistoryIcdNemsisBasicButtonWallOptions,
    ])
    const { entity } = medicalHistoryResponse
    yield put(setPatientMedicalHistoryIcdNemsisBasicOptions(filterHiddenOptions(entity)))
  } catch (e) {
    yield put(throwPcrException(`setMedicalHistoryIcdNemsisBasicOptions() error: ${e}`))
  }
}

export function* setMedicalHistoryIcdNemsisBasicOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setMedicalHistoryIcdNemsisBasicOptions)
}
